import { FontSize } from 'commons';
import { Select, Text } from 'components';
import { Pagination as PaginationType } from 'types';

import { Pagination } from './components';

interface TableFooterProps {
  pagination?: PaginationType;
  changeCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  numberOfPagesToShow?: number;
  isLoading: boolean;
  paginationComponent?: React.ReactNode;
  pageSizeOptions?: number[];
}

const DEFAULT_PAGE_SIZE_OPTIONS = [20, 50, 100];

export function TableFooter({
  pagination,
  changeCurrentPage,
  pageSize,
  setPageSize,
  numberOfPagesToShow,
  isLoading,
  paginationComponent,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: TableFooterProps) {
  if (!pagination || pagination.totalCount === 0) return null;

  const { count, page, totalCount, totalPages } = pagination;

  const stringfiedPageSize = count.toString();
  const isLastPage = totalPages === page + 1;
  const currentItemsCount = isLastPage ? totalCount : count * (page + 1);

  function changePageSize(e: any) {
    const { target } = e;

    if (target) {
      const newValue = Number(target.value);

      setPageSize(newValue);

      changeCurrentPage(0);
    }
  }

  const itemsCountStart = pageSize * page + 1;

  const DefaultPagination = (
    <>
      <Text size={FontSize.font12}>
        <strong>
          Mostrando {itemsCountStart}-{currentItemsCount}{' '}
        </strong>
        de {totalCount} resultados
      </Text>
      <Pagination
        totalPages={totalPages}
        currentPage={page}
        changeCurrentPage={changeCurrentPage}
        numberOfPagesToShow={numberOfPagesToShow}
        isLoading={isLoading}
      />
    </>
  );

  const pageSizeSelectOptions = pageSizeOptions.map(size => ({
    label: size.toString(),
    value: size.toString(),
  }));

  return (
    <div className="flex items-center justify-between flex-wrap gap-8 p-2">
      <div className="max-w-[134px] flex items-center gap-2">
        <Text>Exibir</Text>

        <Select.Wrapper
          name="pageSize"
          onChange={changePageSize}
          topPosition
          initialSelected={{
            label: stringfiedPageSize,
            value: stringfiedPageSize,
          }}
          options={pageSizeSelectOptions}
          disabled={isLoading}
        >
          <Select.Input />

          <Select.StatusArrow />
        </Select.Wrapper>
      </div>

      <div className="flex flex-1 items-center flex-wrap-reverse justify-end gap-y-1 gap-x-4">
        {paginationComponent ?? DefaultPagination}
      </div>
    </div>
  );
}
